import React from 'react';
import './Terms.css';

const Terms: React.FC = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <div className="terms-header">
          <h1 className="terms-title">Terms of Service</h1>
          <p className="terms-subtitle">Last updated: January 2025</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2 className="section-title">Agreement to Terms</h2>
            <p className="section-text">
              By accessing and using GetStrandX, you accept and agree to be bound by the terms and 
              provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">Service Description</h2>
            <p className="section-text">
              GetStrandX is a peer-to-peer roadside assistance platform that connects individuals needing 
              help with nearby community members who can provide assistance. Our platform facilitates 
              connections, processes payments, manages ratings, and provides matching algorithms, but 
              we are not responsible for the actual service delivery between users.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">Platform Features</h2>
            <p className="section-text">
              GetStrandX provides a comprehensive platform including:
            </p>
            <ul className="terms-list">
              <li>Real-time GPS matching and location tracking</li>
              <li>Identity verification and background check integration</li>
              <li>Flexible payment processing (cards, PayPal, Venmo, Zelle)</li>
              <li>Bidirectional rating and review system</li>
              <li>Equipment and service capability tracking</li>
              <li>Dynamic service forms and custom questions</li>
              <li>Automated payout system for helpers</li>
              <li>Push notifications and real-time communication</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">User Responsibilities</h2>
            <h3 className="subsection-title">For Requesters</h3>
            <ul className="terms-list">
              <li>Provide accurate vehicle and location information</li>
              <li>Communicate clearly with helpers about service needs</li>
              <li>Pay for services as agreed upon</li>
              <li>Rate and review service providers honestly</li>
              <li>Follow safety guidelines and local laws</li>
            </ul>

            <h3 className="subsection-title">For Helpers</h3>
            <ul className="terms-list">
              <li>Verify identity and complete background checks</li>
              <li>Provide services in a professional and safe manner</li>
              <li>Maintain appropriate insurance coverage</li>
              <li>Communicate clearly with requesters</li>
              <li>Accept independent contractor status (1099)</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">Payment and Fees</h2>
            <ul className="terms-list">
              <li>Payment is processed securely through third-party providers</li>
              <li>Pricing is transparent and agreed upon before service</li>
              <li>Platform fees are clearly disclosed</li>
              <li>Refunds are handled on a case-by-case basis</li>
              <li>Disputes are resolved through our support system</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">Safety and Liability</h2>
            <p className="section-text">
              <strong>Important:</strong> StrandX is a platform that facilitates connections between users. 
              We are not liable for the actions, services, or safety of individual users. Users participate 
              at their own risk and should exercise appropriate caution.
            </p>
            <ul className="terms-list">
              <li>Users are responsible for their own safety</li>
              <li>We provide identity verification but cannot guarantee user behavior</li>
              <li>Emergency situations should be reported to 911</li>
              <li>Users should trust their instincts and avoid unsafe situations</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">Prohibited Activities</h2>
            <p className="section-text">Users may not:</p>
            <ul className="terms-list">
              <li>Provide false or misleading information</li>
              <li>Engage in fraudulent or illegal activities</li>
              <li>Harass, abuse, or threaten other users</li>
              <li>Use the platform for non-roadside assistance purposes</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">Account Termination</h2>
            <p className="section-text">
              We reserve the right to suspend or terminate accounts that violate these terms or 
              engage in harmful behavior. Users may also delete their accounts at any time.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">Changes to Terms</h2>
            <p className="section-text">
              We may update these terms from time to time. Users will be notified of significant 
              changes, and continued use of the service constitutes acceptance of updated terms.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Terms;
